/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkInfoPendingFileQueryResponse
 */
export interface BulkInfoPendingFileQueryResponse {
    /**
     * 
     * @type {number}
     * @memberof BulkInfoPendingFileQueryResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof BulkInfoPendingFileQueryResponse
     */
    assigned: number;
}

/**
 * Check if a given object implements the BulkInfoPendingFileQueryResponse interface.
 */
export function instanceOfBulkInfoPendingFileQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "assigned" in value;

    return isInstance;
}

export function BulkInfoPendingFileQueryResponseFromJSON(json: any): BulkInfoPendingFileQueryResponse {
    return BulkInfoPendingFileQueryResponseFromJSONTyped(json, false);
}

export function BulkInfoPendingFileQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkInfoPendingFileQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'assigned': json['assigned'],
    };
}

export function BulkInfoPendingFileQueryResponseToJSON(value?: BulkInfoPendingFileQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'assigned': value.assigned,
    };
}

